import { Component, OnInit } from '@angular/core';
import { IHeaderTitle } from 'app/shared/models/header-title';
import { ICompanyAuditDetailsModel } from 'app/company-audit/models/company-audit-details.model';
import { ColumnSortedEvent } from 'app/core/models/column-sorted-model';
import { Routes, ActivatedRoute, Router } from '@angular/router';
import { FormGroup, FormControl, FormBuilder, Validators } from '@angular/forms';
import { SortService } from 'app/core/services/sort.service';
import { debounceTime } from 'rxjs/operators';
import { AccountService } from 'app/core/services/account.service';
import { CompanyAuditService } from 'app/company-audit/services/company-audit.service';
import { CompanyUserModel } from 'app/shared/models/company-user.model';
import { AuditTemplateService } from 'app/audit-template/services/audit-template.service';
import { AuditTemplateModuleDetailsModel } from 'app/audit-template/models/audit-template-module-details.model';
import { Result } from 'app/core/models/result';
import { CompanyAuditModuleViewModel } from '../../models/company-audit-module-view.model';
import { CompanyAuditModuleAddModel } from '../../models/company-audit-module-add.model';
import { LendersModel } from 'app/lenders/models/lenders.model';
import { LendersService } from 'app/lenders/services/lenders.service';
import { BrokersService } from '../../../brokers/services/brokers.service';
import { BrokersModel } from '../../../brokers/models/brokers.model';
import { BrokerModelAdd } from '../../../brokers/models/broker-add.model';
import { SharedService } from '../../../shared/services/shared.service';
import { User } from '../../../shared/models/User';
import { CompanyAuditCommentModel } from '../../models/company-audit-comment.model';

@Component({
  selector: 'app-company-audit-details',
  templateUrl: './company-audit-details.component.html',
  styleUrls: ['./company-audit-details.component.css']
})
export class CompanyAuditDetailsComponent implements OnInit {
    headerTitle: IHeaderTitle;
    errors: string[];
    user: User;
    companyUserList: CompanyUserModel[];
    managerCompanyUserList: CompanyUserModel[];
    companyAuditModel: ICompanyAuditDetailsModel;
    companyTitle: string;
    availableCompaniesNr: number;
    submitAttempt: boolean = false;
    updateAuditFormGroup: FormGroup;
    addAuditSummaryForm: FormGroup;
    auditId: string;
    availableModules: AuditTemplateModuleDetailsModel[];
    selectableModules: AuditTemplateModuleDetailsModel[];
    selectedModules: CompanyAuditModuleViewModel[];
    score: number = 0;
    potentialScore: number = 0;
    totalPercentage: number = 0;
    averageScore: number = 0;
    averageColour: number = 0;
    allowCloseAudit: boolean = false;
    addAuditModuleFormGroup: FormGroup;
    addModule: AuditTemplateModuleDetailsModel;
    addModuleFormVisible: boolean = false;
    lendersList: LendersModel[];
    brokersList: BrokersModel[];
    selectedModuleId: string;
    newBroker: BrokerModelAdd;
    allowComments: boolean = false;
    isEditMode: boolean = false;
    auditComments: CompanyAuditCommentModel[];
    reportDownloading: boolean = false;
    reportDownloaded: boolean = false;
    infoMessage: boolean = false;
    infoMessageText: string;

    constructor(
        private companyAuditService: CompanyAuditService,
        private sharedService: SharedService,
        private activatedRoute: ActivatedRoute,
        private fb: FormBuilder,
        private router: Router,
        private auditTemplateService: AuditTemplateService,
        private lendersService: LendersService,
        private brokersService: BrokersService
    ) {}

    ngOnInit() {
        this.auditId = this.activatedRoute.snapshot.params['id'];
        this.load();
    }

    load = () => {
        this.sharedService.currentUser.subscribe(user => {
            if (user.id) {
                this.user = user;
            }
        });
        this.sharedService.currentCompanyUser.subscribe(companyUser => {
            this.companyUserList = companyUser;
            this.managerCompanyUserList = this.companyUserList.filter(x => x.userTypeId == 2);
        });
        this.companyAuditService.get(this.auditId).subscribe(auditInfo => {
            this.companyAuditModel = auditInfo;
            this.headerTitle = {
                title: auditInfo.title,
                breadcrumbs: [{ title: 'Company Audits', url: ['/company-audit'] }]
            };
            this.auditTemplateService.getAuditTemplateModules(auditInfo.auditTemplateId).subscribe(
                modules => {
                    this.availableModules = modules;
                    this.selectableModules = modules.filter(x => x.isMandatory == false);
                    this.getModulesForAuditInit(auditInfo);
                },
                error => this.errors = error.errorList
            );
            if (
                // check auditorSiteUser/siteUserId is not current user
                (this.companyAuditModel.auditorSiteUserId == "00000000-0000-0000-0000-000000000000" ? this.companyAuditModel.siteUserId : this.companyAuditModel.auditorSiteUserId) != this.user.id
            ){
                this.allowComments = true;
            }
            this.initSummaryForm();

            this.averageScore = auditInfo.averageScore;
            this.getCompany(auditInfo.companyId);
            this.getLenders();
            this.getBrokers();

            this.infoMessageText = this.companyAuditModel.title + " has been assigned to " + this.companyAuditModel.auditorName;
        });
        this.getAuditSummaries();
    }

    calculateaverageColour() {
        if (!this.selectedModules || this.selectedModules.length === 0) {
            this.averageColour = 0;
            return;
        }
        let totalScore = 0;
        let numbOfReviews = 0;
        this.selectedModules.forEach(m => {
            // Only count completed modules
            if (m.moduleStatus === 2) {
                const percent = (m.weightedScore / (m.nrQuestions * 2)) * 100;
                if (percent < 25) totalScore += 1;
                else if (percent <= 75) totalScore += 2;
                else totalScore += 3;
                numbOfReviews++;
            }
        });
        this.averageColour = numbOfReviews > 0 ? totalScore / numbOfReviews : 0;
    }

    // Get existing Modules already assigned to Audit OnInit
    getModulesForAuditInit = (auditInfo: ICompanyAuditDetailsModel) => {
        this.companyAuditService.getAuditModules(auditInfo.id).subscribe(
            modules => {
                if (modules.length == 0) {
                    //this.insertMandatoryModules(this.availableModules);
                    var counter = 0;
                    let mandatoryModules = this.availableModules.filter(x => x.isMandatory == true);
                    mandatoryModules.forEach(m => {
                        counter++;
                        const newAddModule: CompanyAuditModuleAddModel = {
                            companyAuditId: auditInfo.id,
                            moduleId: m.moduleId,
                            moduleDescription: m.name,
                            startDate: auditInfo.startDate,
                            completedDate: null,
                            deadlineDate: auditInfo.deadlineDate,
                            moduleStatus: 0,
                            reviewerSummary: '',
                            reviewerSiteUserId: null,
                            siteUserId: null,
                            customerSurname: '',
                            customerInitial: '',
                            lenderId: null,
                            brokerId: null
                        }
                        this.companyAuditService.addModuleToAudit(newAddModule).subscribe(
                            auditId => {
                                if (counter == mandatoryModules.length) {
                                    this.getModulesForAudit(auditInfo.id)
                                }
                            },
                            error => {
                                this.errors = (<Result>error).errorList;
                            });
                    });
                    this.infoMessage = true;

                } else {
                    this.selectedModules = modules;
                    this.checkCloseAudit();
                    this.calculateaverageColour();
                }
            },
            error => {
                this.errors = (<Result>error).errorList;
            });
    }

    // Get existing Modules already assigned to Audit following updates
    getModulesForAudit(auditId) {
        this.companyAuditService.getAuditModules(auditId).subscribe(
            modules => {
                this.selectedModules = modules;
                this.checkCloseAudit();
            },
            error => {
                this.errors = (<Result>error).errorList;
            });
    }

    hideAddModule(): void {
        this.addModuleFormVisible = false;
    }

    // Open the module details form
    showAddModule(addModule): void {
        // if file audit then show form and allow user to add extra details
        if (this.companyAuditModel.auditCategoryId == 1) {
            this.addModuleFormVisible = true;
            this.addModule = addModule;
            this.addAuditModuleFormGroup = this.fb.group(
                {
                    //auditTemplateId: [addModule.auditTemplateId],
                    //isMandatory: [addModule.isMandatory],
                    //isSingular: [addModule.isSingular],
                    //isActive: [addModule.isActive],

                    //companyAuditId: [this.companyAuditModel.id],
                    //moduleId: [addModule.moduleId],
                    //moduleDescription: [addModule.name],
                    //startDate: [this.companyAuditModel.startDate],
                    //completedDate: [null],
                    //deadlineDate: [this.companyAuditModel.deadlineDate],
                    //moduleStatus: [0],
                    //reviewerSummary: [''],
                    //reviewerSiteUserId: [''],
                    //siteUserId: [''],
                    customerSurname: ['', Validators.required],
                    customerInitial: [''],
                    lenderId: [''],
                    brokerId: ['']
                }
            );
        } else {
            this.addModuleToAudit(addModule);
        }
    }

    initSummaryForm(): void {
        this.addAuditSummaryForm = this.fb.group({
            companyAuditId: [this.companyAuditModel.id],
            siteUserId: [this.user.id],
            comment: ['', [Validators.required, Validators.pattern('^(?! *$).+')]] // Invalid if only spaces
        });
    }

    // User submitted addition of non-mandatory modules
    addModuleToAudit = (addModule) => {
        this.submitAttempt = true;
        this.allowCloseAudit = false;

        //  ----- Function below is required to prevent multiple additions for non-mandatory singular modules -----
        if (addModule.isSingular && this.selectableModules ) {
              this.selectableModules = this.selectableModules.filter(x => x.moduleId != addModule.moduleId);
        }

        const newAddModule: CompanyAuditModuleAddModel = {
            companyAuditId: this.companyAuditModel.id,
            moduleId: addModule.moduleId,
            moduleDescription: addModule.name,
            startDate: this.companyAuditModel.startDate,
            completedDate: null,
            deadlineDate: this.companyAuditModel.deadlineDate,
            moduleStatus: 0,
            reviewerSummary: '',
            reviewerSiteUserId: null,
            siteUserId: this.user.id,
            customerSurname: '',
            customerInitial: '',
            lenderId: '',
            brokerId: ''
        }

        if (this.companyAuditModel.auditCategoryId == 1 && this.addAuditModuleFormGroup.valid) {
            const formValue = this.addAuditModuleFormGroup.value;
            newAddModule.customerSurname = formValue.customerSurname;
            newAddModule.customerInitial = formValue.customerInitial;
            newAddModule.lenderId = formValue.lenderId;

            if (formValue.brokerId) {
                if (this.brokersList.length > 0 && this.brokersList.some(broker => broker.id === formValue.brokerId)) {
                    newAddModule.brokerId = formValue.brokerId;
                    this.submitModuleToAudit(newAddModule);
                } else {
                    const newBroker: BrokerModelAdd = {
                        name: formValue.brokerId,
                        companyId: this.companyAuditModel.companyId
                    }
                    this.brokersService.create(newBroker).subscribe(
                        x => {
                            newAddModule.brokerId = x;
                            this.submitModuleToAudit(newAddModule);
                        },
                        error => {
                            this.errors = (<Result>error).errorList;
                        }
                    )
                }
            } else {
                this.submitModuleToAudit(newAddModule);
            }
        }
    }
    submitModuleToAudit = (newAddModule) => {

        this.companyAuditService.addModuleToAudit(newAddModule).subscribe(
            auditId => {
                this.getModulesForAudit(this.auditId)
                this.getBrokers();
                this.clearForm();
                window.location.reload();
            },
            error => {
                this.errors = (<Result>error).errorList;
            });
    }

    removeModuleFromAudit = () => {
        this.companyAuditService.deleteModuleFromAudit(this.companyAuditModel.id, this.selectedModuleId).subscribe(
            result => {
                this.load();
            },
            error => {
                this.errors = (<Result>error).errorList;
            });
    }

    getCompany = (companyId) => {
        this.companyAuditService.reportAvailableCompanies().subscribe(
            companies => {
                this.availableCompaniesNr = companies.length;
                this.companyTitle = companies.find(x => x.companyId == companyId).companyName;
            },
            error => this.errors = error.errorList
        );
    }

    getLenders = () => {
        this.lendersService.getAll().subscribe(
            result => {
                this.lendersList = result;
            },
            error => {
                this.errors = error.errorList;
            }
        );
    }

    getBrokers = () => {
        this.brokersService.getAllForCompany(this.companyAuditModel.companyId).subscribe(
            result => {
                this.brokersList = result;
            },
            error => {
                this.errors = error.errorList;
            }
        );
    }

    clearForm = () => {
        this.addAuditModuleFormGroup.reset();
    }

    checkCloseAudit = () => {
        if (this.selectedModules.every(x => x.moduleStatus == 2)) {
            this.allowCloseAudit = true;
        }
    }

    closeAudit = () => {
        this.companyAuditService.closeAudit(this.companyAuditModel).subscribe(
            result => {
                this.load();
            }
        );
    }


    toggleEditMode(): void {
        this.isEditMode = !this.isEditMode;
    }

    updateAuditSummary = () => {
        if (this.addAuditSummaryForm.valid) {
            const formValue = this.addAuditSummaryForm.value;
            this.companyAuditService.addCompanyAuditComment(formValue).subscribe(
                auditId => {
                    this.load();
                    this.isEditMode = false;
                },
                error => {
                    this.errors = (<Result>error).errorList;
                });
        }
    }
    getAuditSummaries = () => {
        this.companyAuditService.getCompanyAuditComments(this.auditId).subscribe(
            audits => {
                this.auditComments = audits;
            },
            error => {
                this.errors = (<Result>error).errorList;
            });
    }

  downloadReport = (auditCategoryId: number, companyAuditId: string) => {
    this.reportDownloading = true;
    if (auditCategoryId == 1) {
      // Responsible Lending
      this.companyAuditService.downloadReport('responsible-lending-report', companyAuditId).then(() => {
        this.reportDownloaded = true;
        this.reportDownloading = false;
      });
    } else if (auditCategoryId == 2) {
      // General Business Obligations
      this.companyAuditService.downloadReport('business-obligations-report', companyAuditId).then(() => {
        this.reportDownloaded = true;
        this.reportDownloading = false;
      });
    }
  }
}
